<template>
  <div class="index">
    <div class="header">
      <!-- 头部-顶部 -->
      <div class="header_top">
        <div class="w1200">
          <div class="left fl" style="font-size:12px">{{siteInfos.topDescription}}</div>
          <div class="right fr topmain">
            <a class="fl" v-for="x in toprightArr" :key="x.id" :id="x.id" :href="x.href" :target="x.target" @click="goRouter(x.gorouter)">
              <i class="iconfont">{{x.icon}}</i>{{x.str}}
              <div class="hide" v-if="x.bhtml && x.imgstr">
                <div>
                  <img :src="x.imgstr" />
                  <b style="font-size:12px;" v-html="x.bhtml"></b>
                </div>
                <div v-if="x.imgstr2" style="margin-left:20px;">
                  <img :src="x.imgstr2" />
                  <b style="font-size:12px;" v-html="x.bhtml2"></b>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- 头部-menu -->
      <div class="headermenu">
        <div class="w1200">
          <div class="logo fl">
            <img :src="siteInfo.logo" />
          </div>
          <div class="name fl">
            <a href="javascript:;" class="fl logo-2">
              <b>{{siteInfo.systemName}}</b>
              <p>主办：{{siteInfo.zhuban}}&nbsp;&nbsp;&nbsp;维权：{{siteInfo.weiquan}}</p>
            </a>
          </div>
          <div class="location fl" @click="dialogVisible=true">
            <a href="javascript:;">
              <i class="iconfont">&#xe604;</i>
              <span>{{areaname}}</span>
            </a>
          </div>
          <ul class="menu fr clearfix">
            <li v-for="(item,i) in headNavArr" :key="i" @click="clickHeadNav(item.url,item.replace)">{{item.name}}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 中部 -->
    <keep-alive>
      <router-view ref="children"></router-view>
    </keep-alive>
    <!-- 底部 -->
    <div class="footer">
      <div class="w1200 flex cont">
        <ul v-for="(x1,i1) in footerArr" :key="i1">
          <li class="name">{{x1.title}}</li>
          <li class="list" v-for="(x2,i2) in x1.list" :key="i2" @click="clickFooter(x2)">{{x2.name}}</li>
        </ul>
        <div class="flex codebox">
          <div class="code">
            <img :src="toprightArr[3].imgstr" />
            <p v-html="toprightArr[3].bhtml"></p>
          </div>
          <div class="code">
            <img :src="toprightArr[5].imgstr" />
            <p>微信小程序</p>
          </div>
          <div class="code">
            <img :src="toprightArr[4].imgstr" />
            <p>{{toprightArr[4].bhtml}}</p>
          </div>
          <div class="code">
            <img :src="toprightArr[4].imgstr2" />
            <p>{{toprightArr[4].bhtml2}}</p>
          </div>
          <div class="code">
            <img :src="toprightArr[6].imgstr" />
            <p>微信公众号</p>
          </div>
        </div>
        
      </div>
      <!-- <div class="tips">©{{siteInfos.caseTime}} ©{{siteInfos.copyrightOwner}} 版权所有  <a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber}}</a>   您是本网站第 {{viewNumber}} 位访问者</div> -->
      <div class="show_footer">
        <!-- <span>版权所有 ©{{siteInfos.copyrightOwner}}</span>
        <span><a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber}}</a></span>
        <span><a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber_1}}</a></span>
        <span>您是本网站第 <i class="red">{{viewNumber}}</i> 位访问者</span> -->
        <div>
          <span>
            版权所有 ©{{siteInfos.copyrightOwner}}&nbsp;&nbsp;&nbsp;
            <a href="http://www.ccopyright.com.cn" target="_blank">计算机软件著作权登记证书软著登字第{{siteInfos.computerSoftwareCopyrightNo}}号</a>
            &nbsp;&nbsp;&nbsp;
            <a href="https://sbj.cnipa.gov.cn/sbj/index.html" target="_blank">商标注册证第68407202号</a>
          </span>
        </div>
        <div>
          <span>
            <a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber}}</a>&nbsp;&nbsp;&nbsp;
            <a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber_1}}</a>&nbsp;&nbsp;&nbsp;
            <a href="https://tsm.miit.gov.cn" target="_blank">{{siteInfos.icpEdiNo}}</a>&nbsp;&nbsp;&nbsp;
            <a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+siteInfos.filingNo" target="_blank">川公网安备{{siteInfos.filingNo}}号</a>
          </span>
        </div>
        <div>
          <span>
            全国客服：<a>400&nbsp;–&nbsp;6968&nbsp;–&nbsp;688</a>&nbsp;&nbsp;&nbsp;
            监督投诉：<a>jingcheng@3g48.com</a>&nbsp;&nbsp;&nbsp;
            您是本网站第&nbsp;<i class="red">{{viewNumber}}</i>&nbsp;位访问者
          </span>
        </div>
      </div>
        
    </div>
    <!-- 返回顶部 -->
    <el-backtop></el-backtop>

    <!-- 区域选择弹框 -->
    <el-dialog class="areaChange" title="区域选择" :visible.sync="dialogVisible" width="640px" :close-on-click-modal="false">
      <el-form label-width="100px">
        <el-form-item label="当前区域：">
          <el-input v-model="allAreaName" disabled></el-input>
        </el-form-item>
        <el-form-item label="选择区域：">
          <div class="areaBox">
            <el-select style="max-width:140px;" v-model="placeData[0]" clearable @change="remoteMethod($event, 1)" placeholder="省">
              <el-option v-for="o in province" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-select style="max-width:140px;" v-model="placeData[1]" clearable @change="remoteMethod($event, 2)" placeholder="市">
              <el-option v-for="o in city" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-select style="max-width:140px;" v-model="placeData[2]" clearable @change="remoteMethod($event, 3)" placeholder="县">
              <el-option v-for="o in county" :key="o.id" :label="o.name" :value="o.id"></el-option>
            </el-select>
            <el-button type="primary" @click="changeAreaId()">确 定</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="viewAll">竞成</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// import mixin_area from '@/Mixins/mixin_area'
export default {
  // mixins: [ mixin_area ],
  data() {
    return {
      siteInfos: {
        zhu: {
          logo: require('@/assets/logo.png'),
          systemName: '码上-3G48-AI智慧大数据云视频平台',
          zhuban: '竞成股份',
          weiquan: '成竞律师',
        },
        rsrc: {
          logo: require('@/assets/logo.png'),
          systemName: '码上-3G48-AI智慧大数据云视频平台',
          zhuban: '竞成股份',
          weiquan: '成竞律师',
        },
        copyrightOwner: '成都竞成人力资源服务股份有限公司',
        computerSoftwareCopyrightNo: '10328624',
        caseNumber: '蜀ICP备11025845号',
        caseNumber_1: '蜀ICP备11025845号-1',
        icpEdiNo: 'ICP/EDI川B2-20220159号',
        filingNo: '51010402001408',
        caseTime: '2017-2022',
      },

      areaname: '竞成',//显示所在区域简称，例如 四川成都，只显示成都dialogVisible = false
      allAreaName: '',//显示所在区域全称
      AreaId: '',
      dialogVisible: false,//区域选择弹框的显隐
      province: [],//表单里面的 省市县 的下拉框选项
      city: [],
      county: [],
      placeData: [],//每个下拉框的areaId


      toprightArr: [
        {gorouter:'/login',icon:'\ue61c',str:'登录',},
        {gorouter:'/register',icon:'\ue612',str:'注册',},
        
        {href:'https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Windows_V3.38.2.1.exe',target:'_blank',icon:'\ue786',str:'PC端下载',},
        {href:'javascript:;',id:'App1',icon:'\ue786',str:'APP下载',imgstr:require('./images/androiddownload.png'),bhtml:'安卓扫描二维码<br>苹果搜竞成云视频'},
        {href:'javascript:;',id:'App2',icon:'\ue786',str:'码上',imgstr:require('./images/ewm_ms_ios.png'),bhtml:'码上IOS',imgstr2:require('./images/ewm_ms_android.png'),bhtml2:'码上Android'},
        {href:'https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Mac_V3.37.1.21.dmg',target:'_blank',icon:'\ue786',str:'Mac端下载',},
        {href:'javascript:;',id:'chengxu',icon:'\ue69b',str:'小程序',imgstr:require('./images/ewmxcx_01.jpg'),bhtml:'微信小程序'},
        {href:'javascript:;',id:'gongzhong',icon:'\ue63f',str:'公众号',imgstr:require('./images/ewmgzh_01.jpg'),bhtml:'微信公众号'},
        {href:'javascript:;',id:'weibo',icon:'\ue607',str:'微博',imgstr:require('./images/ewm_02.jpg'),bhtml:'竞成微博'},
        // {href:'http://www.3g48.com/about/',target:'_blank',id:'help',icon:'\ue619',str:'帮助中心'},
        {gorouter:'/articleDetail?catalog=signUp',icon:'\ue619',str:'帮助中心',},
      ],

      footerArr: [
        {title:'关于竞成',list:[
          {name:'竞成简介',url_prefix:'articleDetail?catalog=briefIntroduction&areaNameStr=',url_suffix:'&toptitle=竞成简介'},
          {name:'竞成理念',url_prefix:'articleDetail?catalog=idea&areaNameStr=',url_suffix:'&toptitle=竞成理念'},
          {name:'竞成文化',url_prefix:'articleDetail?catalog=culture&areaNameStr=',url_suffix:'&toptitle=竞成文化'},
          {name:'竞成团队',url_prefix:'articleDetail?catalog=team&areaNameStr=',url_suffix:'&toptitle=竞成团队'},
          {name:'竞成之路',url_prefix:'articleDetail?catalog=routeLine&areaNameStr=',url_suffix:'&toptitle=竞成之路'},
          {name:'联系我们',url_prefix:'articleDetail?catalog=contactUs&areaNameStr=',url_suffix:'&toptitle=联系我们'},
        ]},
        {title:'竞成动态',list:[
          {name:'竞成新闻',url_prefix:'articleList?catalog=news&areaNameStr=',url_suffix:'&toptitle=竞成新闻&page=1'},
          {name:'竞成活动',url_prefix:'articleList?catalog=activity&areaNameStr=',url_suffix:'&toptitle=竞成活动&page=1'},
        ]},
        {title:'竞成声明',list:[
          {name:'知识产权',url_prefix:'articleDetail?catalog=knowledge&areaNameStr=',url_suffix:'&toptitle=知识产权'},
          {name:'网站管理',url_prefix:'articleDetail?catalog=website&areaNameStr=',url_suffix:'&toptitle=网站管理'},
          {name:'隐私保护',url_prefix:'articleDetail?catalog=privacy&areaNameStr=',url_suffix:'&toptitle=隐私保护'},
          {name:'特别声明',url_prefix:'articleDetail?catalog=especially&areaNameStr=',url_suffix:'&toptitle=特别声明'},
        ]},
        {title:'帮助中心',list:[
          {name:'注册登录',url_prefix:'articleDetail?catalog=signUp&areaNameStr=',url_suffix:'&toptitle=注册登录'},
          {name:'单位会员',url_prefix:'articleDetail?catalog=companyVip&areaNameStr=',url_suffix:'&toptitle=单位会员'},
          {name:'个人会员',url_prefix:'articleDetail?catalog=personalVip&areaNameStr=',url_suffix:'&toptitle=个人会员'},
          {name:'如何视频',url_prefix:'articleDetail?catalog=video&areaNameStr=',url_suffix:'&toptitle=如何视频'},
        ]},
        {title:'全国客服',list:[
          {name:'400-6968-688',url:''},
          {name:'投诉监督：jingcheng@3g48.com',url:''},
        ]},
      ],

      viewNumber: '',
    }
  },
  computed: {
    siteInfo() {
      if (['renshi', 'renshiNav'].includes(this.$route.name)) {
        return this.siteInfos.rsrc
      } else {
        return this.siteInfos.zhu
      }
    },
    headNavArr() {
      return [
        {name:'首页',url:'/show'},
        {name:'巩固脱贫',url:'/welcome'},
        {name:'法律维权',url:'/fuwu?areaId='+this.AreaId+'&type=lvshi&page=1',replace:true},
        {name:'就业视吧',url:'/fuwu?areaId='+this.AreaId+'&type=zhaopin&page=1',replace:true},
        {name:'在线培训',url:'/fuwu?areaId='+this.AreaId+'&type=peixun&page=1',replace:true},
        {name:'人事人才',url:'/renshi'},
        {name:'OA系统',url:'http://oa.3g48.com'},
      ]
    },
    provinceId() {
      return this.placeData[0]
    },
    cityId() {
      return this.placeData[1]
    },
  },
  watch: {
    AreaId(val) {
      if (val && val !== '0') {
        this.$api.getPlaceName({ areaId: parseInt(val) }).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            // console.log(`%c地区框:`, 'color: #f00;', _R)
            this.areaname = _R.name
            this.allAreaName = _R.merger_name
          } else { this._status(res.data) }
        })
        this.getViewNumber()
      } else if (val) {
        this.areaname = '竞成'
        this.allAreaName = '竞成'
        this.getViewNumber()
      }
    },
    dialogVisible(val) {//选择区域的弹框隐藏后，重置区域数据
      val ? this.placeData = [] : ''
    },
    pageAreaId_x(val) {
      console.log(val)
      this.getSiteInfo()
    }
  },
  methods: {
    ...mapMutations(['siteNavs_save', 'defaultLogo_save', 'logout']),
    //点击头部的nav
    goRouter(str) {
      str === '/logout'
        ? this.$confirm('是否退出登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api._user_cancellation().then(res => {
              if (res.data.status === 0) {
                this.logout()
                this.$message.success('注销成功')
                this.$router.push('/login')
              } else{ this._status(res.data) }
            })
          }).catch(() => {})
        : this.$router.push(str)
    },
    //点击头部的导航nav
    clickHeadNav(url, replace) {
      if (~url.indexOf('http://') || ~url.indexOf('https://')) { window.open(url) }
      else if (url == '/welcome') {
        this.$api.get_user_login_info().then(res=> {
          if (res.data.status === 0) {
            this.userInfo.admin ? url = '/welcome':''
            this.userInfo.organization ? url = '/companyInfo':''
            this.userInfo.personal ? url = '/userInfo':''
            this.$router.push(url)
          } else { this._status(res.data) }
        })
      }
      else if ( this.$route.name === 'fuwu' && ~url.indexOf('/fuwu')) {
        let ctype = this.$route.query.type
        if (!url.includes(ctype)) {
          console.log(url)
          let ntype = url.match(/type=(\S*)&/)[1]
          console.log(this.$refs.children.navChange(ntype))
        }
      }
      else {
        replace ? this.$router.replace(url) : this.$router.push(url)
      }
    },
    //点击底部的简介
    clickFooter(data) {
      if (data.url != '') {
        this.$router.push(data.url_prefix + this.areaname + data.url_suffix)
      }
    },
    //更换区域id
    changeAreaId() {
      // console.log(this.placeData)
      let arr = this.placeData.filter(x => x)//筛选areaId为空的元素
      if (arr.length > 0) {
        this.AreaId = arr[arr.length-1]
        this.dialogVisible = false
        this.$store.commit('setPageAreaId', this.AreaId)//将区域id保存

        if (['renshi','renshiNav'].includes(this.$route.name)) {//人事方面的页面 更换区域不跳转
        } else if (['articleDetail','articleList'].includes(this.$route.name)) {//文章方面的页面 更换区域跳转到  '联系我们'  页面
          this.$router.push('articleDetail?catalog=contactUs&areaNameStr=竞成&toptitle=联系我们')
        } else {//其他页面更换区域都跳转到服务页面  默认招聘
          this.$router.replace('fuwu?areaId='+this.AreaId+'&type='+this.$route.query.type+'&page=1')
        }
      } else {
        this.$message.info('请选择地区！')
      }
    },
    viewAll() {
      this.AreaId = '0'
      this.dialogVisible = false
      this.$store.commit('setPageAreaId', '0')//将区域id保存
      this.areaname = '竞成'
      this.siteInfos = {
        zhu: {
          logo: require('@/assets/logo.png'),
          systemName: '码上-3G48-AI智慧大数据云视频平台',
          zhuban: '竞成股份',
          weiquan: '成竞律师',
        },
        rsrc: {
          logo: require('@/assets/logo.png'),
          systemName: '码上-3G48-AI智慧大数据云视频平台',
          zhuban: '竞成股份',
          weiquan: '成竞律师',
        },
        gzh: {
          qrcode: require('./images/ewmxcx_01.jpg'),
        },
      }
      if (['renshi','renshiNav'].includes(this.$route.name)) {//人事方面的页面 更换区域不跳转
      } else if (['articleDetail','articleList'].includes(this.$route.name)) {//文章方面的页面 更换区域跳转到  '联系我们'  页面
        this.$router.push('articleDetail?catalog=contactUs&areaNameStr=竞成&toptitle=联系我们')
      } else {//其他页面更换区域都跳转到服务页面  默认招聘
        this.$router.replace('fuwu?areaId=0&type='+this.$route.query.type+'&page=1')
      }
    },
    
    getViewNumber() { // 获取浏览次数
      let rD = {
        id: this.AreaId,
      }
      this.$api.getViewNumber(rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c浏览次数:`, 'color: #f00;', _R)
          this.viewNumber = _R[0].viewNumber
        } else { this._status(res.data) }
      })
    },
    getSiteInfo() { // 获取分站信息
      this.$api.getSystem(this.AreaId).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c分站信息:`, 'color: #f00;', [_R])
          this.siteInfos = {
            zhu: {
              logo: _R.logoId ? this._img_handler(_R.logoId) : require('@/assets/logo.png'),
              systemName: _R.title || '码上-3G48-AI智慧大数据云视频平台',
              zhuban: _R.holdSide || '竞成股份',
              weiquan: _R.maintain || '成竞律师',
            },
            rsrc: {
              logo: _R.rsrcLogo ? this._img_handler(_R.rsrcLogo) : require('@/assets/logo.png'),
              systemName: _R.rsrcTitle || '码上-3G48-AI智慧大数据云视频平台',
              zhuban: _R.rsrcHoldSide || '竞成股份',
              weiquan: _R.rsrcMaintain || '成竞律师',
            },
            topDescription: _R.topDescription || '竞成股份 成竞律师 为您服务！全国客服：400-6968-688',
            copyrightOwner: _R.copyrightOwner || '成都竞成人力资源服务股份有限公司',
            computerSoftwareCopyrightNo: '10328624',
            caseNumber: _R.caseNumber || '蜀ICP备11025845号',
            caseNumber_1: _R.caseNumber_1 || '蜀ICP备11025845号-1',
            icpEdiNo: 'ICP/EDI川B2-20220159号',
            filingNo: '51010402001408',
            caseTime: _R.caseTime || '2017-2022',
            // homeLogoId: _R.homeLogoId ? this._img_handler(_R.homeLogoId) : require('@/views/showpage/images/main_logo.png'),
          }
          this.siteNavs_save(_R.nameAndUrlList)
          // console.log(`%crsrc外链:`, 'color: #f00;', _R.nameAndUrlList)

          if (_R.logoId) {
            this.defaultLogo_save(this._img_handler(_R.logoId))
          } else {
            this.defaultLogo_save(require('@/assets/logo.png'))
          }
          
          this.toprightArr[3].imgstr = _R.videoAppDownloadImgId ? this._img_handler(_R.videoAppDownloadImgId) : require('./images/androiddownload.png')
          this.toprightArr[3].bhtml = (_R.videoAppDownloadDescription || '安卓扫描二维码') + '<br>' + (_R.videoAppDownloadDescription2 || '苹果搜竞成云视频')
          this.toprightArr[4].imgstr = _R.appIosDownloadImgId ? this._img_handler(_R.appIosDownloadImgId) : require('./images/ewm_ms_ios.png')
          this.toprightArr[4].imgstr2 = _R.appAndroidDownloadImgId ? this._img_handler(_R.appAndroidDownloadImgId) : require('./images/ewm_ms_android.png')
          this.toprightArr[4].str = _R.appName || '码上'
          this.toprightArr[4].bhtml = (_R.appName || '码上') + 'IOS'
          this.toprightArr[4].bhtml2 = (_R.appName || '码上') + 'Android'
          this.toprightArr[5].imgstr = _R.smallSoftImgId ? this._img_handler(_R.smallSoftImgId) : require('./images/ewmxcx_01.jpg')
          this.toprightArr[6].imgstr = _R.officialAccountImgId ? this._img_handler(_R.officialAccountImgId) : require('./images/ewmgzh_01.jpg')
          this.toprightArr[7].imgstr = _R.weiboImgId ? this._img_handler(_R.weiboImgId) : require('./images/ewm_02.jpg')


          this.footerArr[0].title = '关于' + (_R.siteName || '竞成')
          this.footerArr[1].title = (_R.siteName || '竞成') + '动态'
          this.footerArr[2].title = (_R.siteName || '竞成') + '声明'

          this.footerArr[0].list[0].name = _R.jingchengIntroduction || '竞成简介'
          this.footerArr[0].list[1].name = _R.jingchengidea || '竞成理念'
          this.footerArr[0].list[2].name = _R.jingchengCulture || '竞成文化'
          this.footerArr[0].list[3].name = _R.jingchengTeam || '竞成团队'
          this.footerArr[0].list[4].name = _R.jingchengRouteLine || '竞成之路'
          this.footerArr[0].list[5].name = _R.jingchengContactUs || '联系我们'
          this.footerArr[1].list[0].name = _R.jingchengNews || '竞成新闻'
          this.footerArr[1].list[1].name = _R.jingchengActivity || '竞成活动'

          this.footerArr[4].list[0].name = _R.customerServicePhone || '400-6968-688'
          this.footerArr[4].list[1].name = '投诉监督：' + (_R.complaintEmail || 'jingcheng@3g48.com')

        } else { this._status(res.data) }
      })
    },
    init() {
      this.$api.get_user_login_info().then(res => {
        if (res.data.status == 0) {//用户已登陆
          localStorage.setItem('loginData', res.data.data)
          let myinfo = {gorouter:'/welcome',icon:'\ue616',str:'我的',}
          let logout = {gorouter:'/logout',icon:'\ue6e2',str:'注销',}
          this.toprightArr.splice(0, 2, myinfo, logout)
          
          this.AreaId = this.pageAreaId_x
          if (this.AreaId === '' || this.AreaId === null) {
            this.AreaId = this.userInfo && this.userInfo.areaId
          }
          if (this.AreaId === '' || this.AreaId === null) {//管理员没有区域id，赋值为登陆地的区域id
            this.$api.position_search({}).then(res => {
              this.AreaId = res.data.data
              this.$store.commit('setPageAreaId', this.AreaId)
            })
          } else {
            this.getViewNumber()
            this.getSiteInfo()
          }
        } else {//用户未登录
          this.AreaId = this.pageAreaId_x
          if (this.AreaId === '' || this.AreaId === null) {//没有区域id，赋值为登陆地的区域id
            this.$api.position_search({}).then(res => {
              this.AreaId = res.data.data
              this.$store.commit('setPageAreaId', this.AreaId)
            })
          } else {
            this.getViewNumber()
            this.getSiteInfo()
          }
        }
      })
    },


    
    // 获取位置
    areaGet(data) {
      this.$api.getSubsite(data.value).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(data.key) {
            case 0: this.province = _R; break;
            case 1: this.city = _R; break;
            case 2: this.county = _R; break;
            case 3: this.town = _R; break;
            case 4: this.village = _R; break;
            case 5: this.village = _R; break;
          }
        } else {
          this.$message.error('获取失败')
        }
      })
    },
    // 清空下级
    remoteMethod(value, num) {
      switch(num) {
        case 1: this.placeData[1] = this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break;
        case 2: this.placeData[2] = this.placeData[3] = this.placeData[4] = ''; break;
        case 3: this.placeData[3] = this.placeData[4] = ''; break;
        case 4: this.placeData[4] = ''; break;
      }
      if (value) {
        this.areaGet({ value: { parentId: value }, key: num })
      }
      let place = this.placeData.filter(x => x)
      if (place.length) {
        let parentId = place[place.length - 1]
        this.afterAreaGet && this.afterAreaGet(parentId)
      }
    },
  },
  created() {
    this.init()
    this.areaGet({ value: { parentId: 'root' }, key: 0 })
  },
}
</script>

<style lang='scss' scoped>
/deep/ .el-backtop{width: 40px;height: 40px;}

/* 头部 */
.header{height: 130px;width: 100%;}
.header .header_top{background-color: #1E9FFF;color: #ffffff;}
.header .header_top .w1200{margin: 0px auto;height: 40px;line-height: 40px;}
.header_top .topmain{line-height: 40px;height: 100%;width: auto;}
.header_top .topmain a {color: #ffffff;cursor: pointer;margin-right: 15px;font-size: 14px;position: relative;}
.header_top .topmain .fl i{margin-right: 5px;}
.header_top .topmain .fl i :after{display: none;margin-right: 5px;}
.header_top .topmain #App1:hover .hide,
.header_top .topmain #App2:hover .hide,
.header_top .topmain #chengxu:hover .hide,
.header_top .topmain #gongzhong:hover .hide,
.header_top .topmain #weibo:hover .hide,
.header_top .topmain #help:hover .hide{z-index: 10;display: flex;justify-content: space-between;align-items: center;}
.header_top .topmain a .hide{
  color: #303133;top: 39px;display: none;padding: 15px;left: -35px;
  position: absolute;min-width: 140px;line-height: 16px;border: 1px solid #1E9FFF;
  box-shadow: 0 5px 5px 5px rgba(0,0,0,0.1);text-align: center;background-color: #fff;
}
.header_top .topmain a .hide img{width: 140px;height: 140px;}
/* 头部顶部结束 */

.headermenu{padding: 20px 0px;width: 100%;}
.headermenu .w1200{height: 50px;}
.headermenu .logo img{width: 50px;}
.headermenu .name{margin-left: 10px;}
.headermenu .name b{display: block;font-size: 26px;color: #1E9FFF;font-weight: bold;margin-top: -5px;}
.headermenu .name p{color: #666666;font-size: 14px;}
 
.headermenu .location{font-size: 14px;text-align: center;margin-left: 20px;background-color: #ffffff;border: 1px solid #eeeeee;border-radius: 3px;padding: 4px 10px;font-size: 14px;cursor: pointer;}
.headermenu .location i{width: 14px;height: 14px;float: left;margin: 2px 5px 0 0;}
.headermenu .menu{margin-top: 10px;}
.headermenu .menu li{float: left;font-size: 18px;padding-left: 15px;}
.headermenu .menu li:hover{color: #1E9FFF;cursor: pointer;}

.footer{padding-top: 20px;background-color: #f3f3f3;border-top: 1px solid #eeeeee;padding-bottom: 80px;position: relative;}
.footer .cont{justify-content: space-between;align-items:stretch;}
.footer ul{/* margin-right: 100px; */}
.footer ul li{font-size: 14px;color: #666666;line-height: 30px;display: block;}
.footer ul li.name{font-size: 16px;display: block;line-height: 30px;color: #444444;}
.footer ul li.list{cursor: pointer;}
.footer ul li.list:hover{color: red;}
.footer .codebox{justify-content: space-between;align-items:stretch;width: 620px;}
.footer .code{text-align: center;}
.footer .code img{width: 120px;height: 120px;}
 .code p{font-size: 12px;display: block;color: #666666;text-align: center;padding-top: 10px;}
// .footer .tips{font-size: 12px;line-height: 45px;text-align: center;color: #999999;padding: 10px 0px;}

/* 底部 */
.show_footer{line-height: 1.6;font-size: 14px;color: #999999;text-align: center;padding: 5px;position: absolute;bottom: 0;left: 0;right: 0;z-index: 1;}
.show_footer span{padding: 0px 5px;}
.show_footer span a{color: #999999;}
.show_footer span i{font-style: normal;}

/* 返回顶部 */
.gobacktop{position: relative;width: 100%;height: 100%;}
.gobacktop i{position: absolute;top: 13px;left: 15px;font-size: 50px;color: #999;}
.gobacktop:hover i{color:#1E9FFF;}

.areaChange{height: 300px;margin-top: 200px!important;}
/* 更改区域 弹框 */
.areaBox{display: flex;justify-content: space-between;}
.areaBox .el-select{width: 30%;}
</style>